import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {Order} from "../../../../store/state/order.state";
import {EndpointsProvider} from "../../../endpoints/endpoint-provider.service";

@Injectable()
export class ReviewerDocumentOrderResolver implements Resolve<Order> {

	constructor(private endpoints: EndpointsProvider) {
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Order> {
		const correlationId: string = route.paramMap.get('orderCorrelationId');
		return this.endpoints.review.getOrderForApplicationReview(correlationId);
	}
}
